import React from 'react';
import { Drawer } from 'vaul';
import Modal from './Modal';
import { useWindows } from '../contexts/WindowsContext';

interface AdaptiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function AdaptiveModal({ isOpen, onClose, title, children, footer, size = 'md' }: AdaptiveModalProps) {
  const { isMobile } = useWindows();

  if (!isMobile) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} title={title} size={size}>
        {children}
        {footer}
      </Modal>
    );
  }

  return (
    <Drawer.Root open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/60 z-[60]" />
        <Drawer.Content
          className="fixed bottom-0 left-0 right-0 z-[60] bg-white dark:bg-gray-800 rounded-t-2xl flex flex-col outline-none"
          style={{ maxHeight: '96dvh' }}
        >
          {/* Drag handle */}
          <div className="mx-auto w-12 h-1.5 bg-gray-300 dark:bg-gray-600 rounded-full my-3 flex-shrink-0" />

          {title && (
            <h2 className="text-lg font-bold px-4 pb-3 text-gray-900 dark:text-gray-100">
              {title}
            </h2>
          )}

          <div
            className="flex-1 overflow-y-auto px-4"
            style={{ paddingBottom: footer ? '8px' : `calc(16px + var(--sab))` }}
          >
            {children}
          </div>

          {footer && (
            <div
              className="flex-shrink-0 px-4 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
              style={{ paddingBottom: `calc(12px + var(--sab))` }}
            >
              {footer}
            </div>
          )}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
